import { render, staticRenderFns } from "./EventPlan.vue?vue&type=template&id=2c9bc25c&"
import script from "./EventPlan.vue?vue&type=script&lang=js&"
export * from "./EventPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports